import type { Address } from '@/types';

export interface AddressDisplayProps {
  readonly address: Partial<Address>;
  readonly 'data-testid'?: string;
}

const AddressDisplay = ({
  address: fullAddress,
  'data-testid': dataTestId = 'address-display',
}: AddressDisplayProps): JSX.Element | null => {
  const {
    country = '',
    fname = '',
    lname = '',
    email = '',
    address = '',
    address2 = '',
    attention = '',
    city = '',
    state = '',
    postal = '',
    phone = '',
  } = fullAddress;

  return (
    <ol
      data-testid={dataTestId}
      data-fname={fname}
      data-lname={lname}
      data-email={email}
      data-address={address}
      data-address2={address2}
      data-attention={attention}
      data-city={city}
      data-state={state}
      data-postal={postal}
      data-country={country}
      data-phone={phone}
      hidden={Object.values(fullAddress).every((val) => !val)}
    >
      <li
        data-testid={`${dataTestId}-name`}
        hidden={[fname, lname].every((val) => !val)}
      >
        {fname} {lname}
      </li>

      <li data-testid={`${dataTestId}-email`} hidden={!email}>
        {email}
      </li>

      <li data-testid={`${dataTestId}-address`} hidden={!address}>
        {address}
      </li>

      <li data-testid={`${dataTestId}-address2`} hidden={!address2}>
        {address2}
      </li>

      <li data-testid={`${dataTestId}-attention`} hidden={!attention}>
        {attention}
      </li>

      <li
        data-testid={`${dataTestId}-city-state-zip`}
        hidden={[city, state, postal].every((val) => !val)}
      >
        {city}
        {state ? `, ${state} ` : ' '}
        {postal}
      </li>

      <li data-testid={`${dataTestId}-country`} hidden={!country}>
        {country}
      </li>

      <li data-testid={`${dataTestId}-phone`} hidden={!phone}>
        {phone}
      </li>
    </ol>
  );
};

export default AddressDisplay;
